import React, { useReducer, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import './Assign-Category-Popup.scss';
import { Button } from '@material-ui/core';
import CustomSelect from '../form-controls/custom-select/Custom-Select';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const AssignCategoryPopupModel = (props) => {
  const { data, onConfirm, listCategory, onClickCancel } = props;
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const handleClose = () => {
    onClickCancel();
  };

  const onConfirmClick = () => {
    const newCategoryName = listCategory.find(
      (cate) => cate.id === formData.newSelectedCategory.value,
    ).name;
    onConfirm(formData.newSelectedCategory.value, newCategoryName);
  };

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    newSelectedCategory: {
      value: '',
      fieldName: 'Select Category',
      errors: {},
      validations: ['required'],
    },
  });

  const setId = (e) => {
    setLoading(true);
    setFormData({ newSelectedCategory: e });
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='custom-popup'>
        <div className='popup-title'>Reassign Channels</div>
        <div className='popup-sub-title'>{data.category.numberOfChannels} Selected</div>
        <div>
          <CustomSelect
            valueField='id'
            labelField='name'
            item={formData.newSelectedCategory}
            handleInputChange={(e) => {
              setId(e);
            }}
            options={listCategory}
            hideNullOption
          />
        </div>
        <p className='popup-description'>
          The selected channels will be assigned to the new category
        </p>
        <div className='col-md-10 offset-1 d-flex justify-content-around px-4 mt-4'>
          <Button variant='outlined' size='large' color='secondary' onClick={(e) => handleClose()}>
            Cancel
          </Button>
          <Button
            disabled={!loading}
            variant='contained'
            size='large'
            color='primary'
            onClick={(e) => onConfirmClick()}
          >
            Confirm
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Modal open={data.status} onClose={handleClose}>
        {body}
      </Modal>
    </div>
  );
};

export default AssignCategoryPopupModel;
